import {H2, H3} from "@mc/ui-v3";
import React from "react";
import {connect} from "react-redux";
import PecetForm from "../administrace/forms/PecetForm";
import AdminMenu from "../administrace/lists/components/AdminMenu";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import CustomPageLayout from "./CustomPageLayout";
import {Button} from "reactstrap";
import {toastr} from "../utils/mc-toastr";
import PodpisForm from "../administrace/forms/PodpisForm";
import PozadavkyForm from "../administrace/forms/PozadavkyForm";
import * as groupMenuConfigActions from "../actions/groupMenuConfigActions";


class VisualizationPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {requestConfig: null, signData: null, sealData: null, failedSeals: null, fonts: [], disabled: false};
    }

    componentDidMount() {
        Promise.all([
            SignRequestInternalApi.getRequestConfig(),
            SignRequestInternalApi.getVisualSign(),
            SignRequestInternalApi.getGraphicSeal(),
            SignRequestInternalApi.getSealingErrors(),
            SignRequestInternalApi.getAvailableFonts()
        ]).then((values) => {
            this.setState({requestConfig: values[0], signData: values[1], sealData: values[2], failedSeals: values[3], fonts: values[4]})
        });

    }

    updateSignConfig = (newConfig) => {
        return SignRequestInternalApi.updateVisualSign(newConfig).then((res) => {
            this.setState({signData: newConfig});
            toastr.success("Aktualizace podpisu proběhla úspěšně")
        })
    };

    updateSealConfig = (newConfig) => {
        return SignRequestInternalApi.updateGraphicSeal(newConfig).then((res) => {
            this.setState({sealData: newConfig});
            toastr.success("Aktualizace pečetě proběhla úspěšně")
        })
    };

    updateRequestConfig = (newConfig) => {
        const {dispatch} = this.props;

        return SignRequestInternalApi.updateRequestConfig(newConfig).then((res) => {
            this.setState({requestConfig: newConfig});
            toastr.success("Aktualizace proběhla úspěšně")
            dispatch(groupMenuConfigActions.invalidate())
        })
    };

    render() {
        const {requestConfig, signData, sealData, failedSeals, fonts, disabled} = this.state;


        return (
            <CustomPageLayout header headerButton={false} searchField={false} title="Podpis a pečeť" menu={<AdminMenu/>}>
                {requestConfig && <div className="mb-5 mt-3 ml-5">
                    <h2>{"Vlastní požadavky"}</h2>
                    <PozadavkyForm onSubmit={this.updateRequestConfig} initialValues={requestConfig}/>
                </div>}
                {signData && fonts && <div className="mb-5 mt-3 ml-5">
                    <h2>{"Vizuální podpis"}</h2>
                    <PodpisForm onSubmit={this.updateSignConfig} initialValues={signData} fonts={fonts}/>
                </div>}
                {sealData && <div className="mb-5 mt-3 ml-5">
                    <h2>{"Vizuální pečet"}</h2>
                    <PecetForm onSubmit={this.updateSealConfig} initialValues={sealData}/>
                </div>}
                {failedSeals > 0 && [
                    <hr/>,
                    <div className="d-flex justify-content-center align-items-center">
                        <H3 className={"mr-3"}>{`Nedokončené pečetě ${failedSeals}`}</H3>
                        <Button color="primary" disabled={disabled} onClick={() => {
                            SignRequestInternalApi.repeatFailedSealings().then(() => {
                                toastr.success("Opětovné zahájení pečetění");
                                this.setState({disabled: false});
                                SignRequestInternalApi.getSealingErrors().then((res) => this.setState({failedSeals: res}));
                            }).catch(() => {
                                toastr.error("Chyba během zahájení pečetění");
                                this.setState({disabled: false})
                                SignRequestInternalApi.getSealingErrors().then((res) => this.setState({failedSeals: res}));
                            });
                            this.setState({disabled: true})
                        }}>Pustit znovu</Button>
                    </div>]}
            </CustomPageLayout>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(VisualizationPage);
